import { useState, type FC } from 'react';

import { Button, Modal, Textarea } from '@g2u/ui-kit';
import { Form, Popconfirm } from 'antd';
import { RootStore } from '../../../../store';
import { Role } from '../../../../types';

type Props = Readonly<{
  isBlacklisted: boolean;
  onAdd: (note: string, isBlacklisted: boolean) => void;
}>;

export const BlacklistTechnician: FC<Props> = (props: Props) => {
  const { isBlacklisted, onAdd } = props;
  const [showModal, setShowModal] = useState<boolean>(false);
  const [form] = Form.useForm();

  const { user } = RootStore;

  const handleBlacklistTechnician = (values: { note: string }) => {
    setShowModal(false);
    onAdd(values.note, isBlacklisted);
  };

  return (
    <>
      <Popconfirm
        title={isBlacklisted ? 'Remove Technician from Blacklist' : 'Blacklist Technician'}
        description={
          <>
            Are you sure you want to
            <br /> {isBlacklisted ? 'remove the technician from blacklist?' : 'blacklist this technician?'}
          </>
        }
        onConfirm={() => setShowModal(true)}
        okText="Yes"
        cancelText="No"
      >
        <Button.$
          danger
          dataTestId="blacklist-tech-btn"
          disabled={user?.role === Role.CSS || user?.role === Role.CSSPlus}
          onClick={() => {}}
        >
          {isBlacklisted ? 'Remove from Blacklist' : 'Blacklist Technician'}
        </Button.$>
      </Popconfirm>

      <Modal.$
        width={550}
        dataTestId="balcklist-tech-modal"
        open={showModal}
        title={isBlacklisted ? 'Remove Technician from Blacklist' : 'Blacklist Technician'}
        okText="Save"
        onCancel={() => {
          setShowModal(false);
        }}
        onOk={() => {
          form.submit();
        }}
      >
        <Form form={form} onFinish={handleBlacklistTechnician} labelAlign="left" layout="horizontal" preserve={false}>
          <Textarea.$ name="note" label="Note" rules={[{ required: true }]} required />
        </Form>
      </Modal.$>
    </>
  );
};
